<template>
  <div v-if="audioUrl" class="audio-player-container">
    <audio ref="audioPlayer" :src="audioUrl" class="audio-element" controls></audio>
  </div>
</template>

<script>
export default {
  name: "AudioPlayer",
  props: {
    audioUrl: {
      type: String,
      required: true
    }
  },
  methods: {
    stopAudioPlayer() {
      const audioPlayer = this.$refs.audioPlayer;
      if (audioPlayer) {
        audioPlayer.pause();
        audioPlayer.currentTime = 0;
      }
    }
  },
  beforeDestroy() {
    this.stopAudioPlayer();
  }
};
</script>

<style scoped>
.audio-player-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px;
  padding: 2rem;
  margin: 1rem 0;
  background: white;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  text-align: center;
  width: 100%;
}

.audio-element {
  width: 100%;
  max-width: 400px;
  height: 50px;
  border-radius: 8px;
  outline: none;
}

.audio-element::-webkit-media-controls-panel {
  background-color: #f8f9fa;
  border-radius: 8px;
}

.audio-element::-webkit-media-controls-play-button,
.audio-element::-webkit-media-controls-pause-button {
  background-color: #007bff;
  border-radius: 50%;
}

.audio-element::-webkit-media-controls-timeline {
  background-color: #e9ecef;
  border-radius: 4px;
}

.audio-element::-webkit-media-controls-current-time-display,
.audio-element::-webkit-media-controls-time-remaining-display {
  color: #495057;
  font-size: 0.875rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .audio-player-container {
    padding: 1rem;
    min-height: 250px;
  }
}

@media (max-width: 480px) {
  .audio-player-container {
    padding: 0.75rem;
    min-height: 200px;
  }
}
</style> 